window.initGoogleMaps = () => {
  $(document.body).trigger("google_maps:load_success")
}

window.onGoogleLoad = callback => {
  if (window.google) {
    callback()
  } else {
    $(document.body).on("google_maps:load_success", callback)
  }
}


// WEBPACK FOOTER //
// ./app/webpack/frontend/config/GoogleMaps.js